import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import isDesktopSelector from 'store/app/selector/isDesktop';

export default (({ children }) => {
  const isDesktopSelected = useSelector(isDesktopSelector);
  return <>{isDesktopSelected ? null : children}</>;
}) as React.FC<PropsWithChildren<unknown>>;
